export default (target: Ref<HTMLElement | null>) => {
  const isIntersecting = ref(false)

  useIntersectionObserver(target, ([entry]) => {
    isIntersecting.value = entry?.isIntersecting || false
  })

  return { isIntersecting }
}
